import { useContext, useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PrivateRouteI } from 'src/models/router';
import { getFallbackPath } from 'src/utils/route';
import {
  isAdminLoggined,
  isCustomerLoggined,
  ADMIN_REDIRECT_URL_KEY,
  CUSTOMER_REDIRECT_URL_KEY
} from 'src/utils/auth';
import { AuthRole } from 'src/enums/auth';
import { ProfileContext } from 'src/contexts/profile';
import Cookies from 'js-cookie';

export const PrivateRoute = ({
  children,
  role,
  requirePermission,
  requireAnyPermission
}: PrivateRouteI) => {
  const { hasRole, hasAnyOfRoles, fetchProfile, isProfileLoading } =
    useContext(ProfileContext);
  const location = useLocation();

  const isLogined = useMemo(() => {
    if (role === AuthRole.ADMIN) {
      return isAdminLoggined();
    }
    if (role === AuthRole.CUSTOMER) {
      return isCustomerLoggined();
    }
    return false;
  }, [role]);

  useEffect(() => {
    if (isLogined) {
      fetchProfile?.();
    }
  }, [location.pathname]);

  const fallbackPath = getFallbackPath(location.pathname);

  useEffect(() => {
    if (!isLogined) {
      const redirectUrl = location.pathname + location.search;
      if (role === AuthRole.ADMIN) {
        if (!Cookies.get(ADMIN_REDIRECT_URL_KEY)) {
          Cookies.set(ADMIN_REDIRECT_URL_KEY, redirectUrl, { expires: 1 });
        }
      } else if (role === AuthRole.CUSTOMER) {
        if (!Cookies.get(CUSTOMER_REDIRECT_URL_KEY)) {
          Cookies.set(CUSTOMER_REDIRECT_URL_KEY, redirectUrl, { expires: 1 });
        }
      }
    }
  }, [isLogined, location.pathname, location.search, role]);

  if (!isLogined) return <Navigate to={fallbackPath} replace />;
  if (role === AuthRole.CUSTOMER) return children;
  if (isProfileLoading) return <></>;
  const isForbidden =
    (requirePermission && !hasRole(requirePermission)) ||
    (requireAnyPermission && !hasAnyOfRoles(requireAnyPermission));
  if (isForbidden) {
    return (
      <div className="h-[calc(100vh-60px)] flex justify-center items-center font-extrabold text-3xl">
        この画面はアクセス権限がありません。
      </div>
    );
  }

  return children;
};
